import {PerformanceAdvice} from './performance-advice';
import {Utils} from '../../../../shared/utils/utils';
import {TextUtils} from '../../../../shared/utils/text-utils';

export class PerformanceAdviceMapper {

  public static parseAdvices(adviceMap: any): PerformanceAdvice[] {
    let advices: PerformanceAdvice[] = [];
    const categories: any[] = [
      {
        id: 'performance',
        name: TextUtils.getText('text_performance')
      },
      {
        id: 'bestpractice',
        name: TextUtils.getText('text_performance.adviceCategoryBestPractice')
      },
      {
        id: 'accessibility',
        name: TextUtils.getText('text_performance.adviceCategoryAccessibility')
      }
    ];

    categories.forEach((categoryData: any): void => {
      Object.values(adviceMap[categoryData.id].adviceList).reduce((categoryAdvices: PerformanceAdvice[], adviceData: any): PerformanceAdvice[] => {
        categoryAdvices.push(PerformanceAdviceMapper.map(adviceData, categoryData.name));

        return categoryAdvices;
      }, advices);
    });

    return advices;
  }

  public static map(data: any, type: string): PerformanceAdvice {
    const performanceAdvice: PerformanceAdvice = new PerformanceAdvice();

    performanceAdvice.type = type;
    performanceAdvice.title = data.title;
    performanceAdvice.score = data.score;
    performanceAdvice.grade = Utils.getPerformanceGrade(data.score);
    performanceAdvice.advice = data.advice;

    return performanceAdvice;
  }

}
